<template>
  <div class="home">
    <banner :slides="slides" />
    <newsModal :show.sync="newsShow" :content="news" />
    <section class="products row no-gutters">
      <div
        class="product col-md-4 col-6"
        v-for="item in categories"
        :key="item.id"
      >
        <div class="product-box" @click="handleCategoryClick(item)">
          <div class="product-title">
            <p>{{ item.categoryName }}</p>
            <router-link :to="`${item.routing}${item.id}`" class="btn btn-view"
              >查看</router-link
            >
          </div>
        </div>
        <div class="product-img">
          <img
            :src="handleCategory(item.categoryPoster)"
            class="img-fluid"
            :alt="item.categoryName"
          />
        </div>
      </div>
    </section>
    <section class="about row no-gutters">
      <p v-if="$isMobile" class="about-title">
        关于
        <span class="text-secondary">金穗联创</span>
      </p>
      <div class="col-md-6">
        <img
          class="img-fluid"
          src="../assets/images/home/home-about-new.jpg"
          alt="金穗联创"
        />
      </div>
      <div class="col-md-6 about-des">
        <div class="about-des-warp">
          <p v-if="!$isMobile" class="about-title">
            关于
            <span class="text-secondary">金穗联创</span>
          </p>
          <p>
            北京金穗联创科技有限公司是行业AI智能产品和解决方案提供商。我们致力于把AI技术、5G技术、物联网技术带入传统行业，利用科技为传统行业赋能，为行业客户提供能够实现减员增效、智能便利、节能降耗的产品和解决方案。我们以”客户第一、结果导向、极致思维“为客户服务理念，经过多年发展积累了在轨道交通、市政、房建、公路、石油石化、核电等领域的服务经验，能够为客户提供优质、极致的产品和定制服务。
          </p>
          <router-link to="about" class="btn btn-view">查看更多</router-link>
        </div>
      </div>
    </section>
    <section class="brand">
      <h2>
        产品
        <span class="text-secondary">动态</span>
      </h2>
      <div v-if="!$isMobile" class="brand-items">
        <div class="self-button-prev">
          <img class="img-fluid" src="../assets/images/home/left.png" alt />
        </div>
        <div class="self-button-next">
          <img class="img-fluid" src="../assets/images/home/right.png" alt />
        </div>
        <div class="swiper-wrapper">
          <div
            class="brand-item swiper-slide"
            v-for="item in brand"
            :key="item.id"
          >
            <div class="row">
              <div class="col-5 brand-item-warp">
                <h3 class="brand-item-title">{{ item.title }}</h3>
                <p class="brand-item-content">{{ item.summary }}</p>
                <p @click="handleNews(item)" class="brand-item-more">
                  了解更多+
                </p>
              </div>
              <div class="col-7" style="display: flex;align-items: center;">
                <img
                  class="img-fluid"
                  :src="item.avatar || '../assets/images/home/home-about.png'"
                  :alt="item.title"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="$isMobile" class="brand-items">
        <div class="swiper-wrapper">
          <div
            class="brand-item swiper-slide card"
            v-for="item in brand"
            :key="item.id"
          >
            <div class="brand-item-warp">
              <img
                class="img-fluid"
                :src="item.avatar || '../assets/images/home/home-about.png'"
                :alt="item.title"
              />
              <h3 class="brand-item-title">{{ item.title }}</h3>
              <p class="brand-item-content">{{ item.summary }}</p>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: center;">
        <router-link to="brand" class="btn btn-view">查看更多</router-link>
      </div>
    </section>
    <!--    <section class="friends">
      <h2 class="about-title">
        合作
        <span class="text-secondary">平台</span>
      </h2>
      <div v-if="!$isMobile" class="list">
        <img
          class="img-fluid list-left"
          src="../assets/images/home/left.png"
          alt
        />

        <div class="list-warp">
          <div class="row" v-for="(col, index) in links" :key="index">
            <div class="item col-md-1-5">
              <a>
                <img
                  class="img-fluid"
                  :src="`${publicPath}friend/logo-${index}.png`"
                />
              </a>
            </div>
            <div class="col row">
              <div class="item col-md-3" v-for="item in col" :key="item.id">
                <a :href="item.link">
                  <img
                    class="img-fluid"
                    :src="item.icon || '../assets/images/home/shang-92.png'"
                    :alt="item.friendName"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <img
          class="img-fluid list-right"
          src="../assets/images/home/right.png"
          alt
        />
      </div>
      <div v-if="$isMobile" class="list">
        <div class="list-warp">
          <div class="row">
            <template v-for="col in links">
              <div class="item col-4" v-for="item in col" :key="item.id">
                <a :href="item.link">
                  <img
                    class="img-fluid"
                    :src="item.icon || '../assets/images/home/shang-92.png'"
                    :alt="item.friendName"
                  />
                </a>
              </div>
            </template>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import banner from "@/components/banner";
import newsModal from "@/components/newsModal";
import Swiper from "swiper";
import slides from "@/config/banner.js";

export default {
  name: "home",
  components: {
    banner,
    newsModal
  },
  data() {
    return {
      categories: [],
      brand: [],
      links: [],
      publicPath: process.env.BASE_URL,
      newsShow: false,
      news: {},
      mySwiper: null,
      slides
    };
  },
  created() {
    this.getCategory();
    this.linkData();
  },
  mounted() {
    this.brandData();
  },
  methods: {
    // 获取首页轮播
    getCover() {},
    getCategory() {
      this.$api.category.getCategoryList({
		  level:0
	  }).then(res => {
        this.categories = res.result;
      });
    },
    handleCategory(data) {
      let arr = JSON.parse(data);
      return arr[0];
    },
    initSwiper() {
      let width = document.body.clientWidth;
      let gutter = width / 40;
      let opt;
      if (this.$isMobile) {
        opt = {
          speed: 2000,
          spaceBetween: 20,
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: true
          },
          loop: true
        };
      } else {
        opt = {
          normalizeSlideIndex: false,
          slidesPerView: 2,
          loop: true,
          spaceBetween: gutter,
          slidesOffsetBefore: width / 4,
          navigation: {
            nextEl: ".self-button-next",
            prevEl: ".self-button-prev"
          },
          speed: 2000,
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: true
          }
        };
      }

      this.mySwiper = new Swiper(".brand-items", opt);
    },
    brandData() {
      this.$api.brand
        .getBrandList({ pageSize: 6, pageNo: 1, category: "corporate" })
        .then(res => {
          this.brand = res.result.records;
          this.$nextTick(() => {
            this.initSwiper();
          });
        });
    },
    linkData() {
      this.$api.friendLink.getFriendList().then(res => {
        this.links = res.result;
      });
    },
    handleNews(news) {
      if (this.$isMobile) {
        this.$router.push("/news/" + news.id);
      } else {
        this.news = news;
        this.newsShow = true;
      }
    },
    handleCategoryClick(item) {
      if (this.$isMobile) {
        this.$router.push(item.routing + item.id);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.col-md-1-5 {
  position: relative;
  min-height: 1px;
  padding-right: 10px;
  padding-left: 10px;
}
.home {
  h2 {
    @include responsive-font-size(48px);
    text-align: center;
  }
  .products {
    display: flex;
    .product {
      max-height: 450px;
      border: 1px solid #9f9f9f;
      .img-fluid {
        width: 100%;
      }
      &-img {
        background: #000;
        img {
          opacity: 0.6;
        }
      }
      &-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #fff;
        height: 60%;
        overflow: auto;
        margin: auto;
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        transition: background 1s;
        p {
          text-align: center;
        }

        &:hover {
          background: rgba(0, 0, 0, 0.6);
        }
      }
      &-title {
        @include responsive-font-size(30px);
        width: 45%;
        text-align: center;
      }
    }
  }
  .about {
    background: #d2d2d2;
    padding: 60px 0;
    &-des {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 2rem;
      @include responsive-font-size(20px);

      // align-items: center;
    }
    &-des-warp {
      width: 80%;
    }
    &-title {
      @include responsive-font-size(48px);
    }
    .btn-view {
      background-color: rgba(41, 67, 154, 0.65);
    }
  }
  .brand {
    background: #e3e3e3;
    padding: 60px 0;
    overflow: hidden;

    h2 {
      @include responsive-font-size(48px);
      text-align: center;
    }
    &-items {
      padding: 50px 0;
      position: relative;
    }
    $item-padding: 60px;

    .swiper-slide-prev {
      background: rgba(255, 255, 255, 1);
      opacity: 0.2;
    }
    .swiper-slide-next {
      opacity: 0.5;
      background: rgba(255, 255, 255, 0.5);
      color: #fff;
      a {
        color: #fff;
      }
    }
    .swiper-slide-active {
      box-shadow: 6px 6px 8px -3px #999;
      border: 1px solid #ccc;
    }
    .self-button-prev {
      position: absolute;
      left: 10%;
      top: 50%;
      z-index: 2;
      bottom: 0;
      margin-top: -6vw;
      width: 6vw;
    }
    .self-button-next {
      position: absolute;
      right: 10%;
      top: 50%;
      z-index: 2;
      bottom: 0;
      margin-top: -6vw;
      width: 6vw;
    }

    &-item {
      padding: $item-padding/2;
      width: 50vw;
      // height: 25vw;
      transition: box-shadow 2s, color 2s, opacity 2s, background 2s;

      img {
      }
      &-warp {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
      &-title {
        font-size: 1.2rem;
      }
      &-content {
        overflow: hidden;
        -o-text-overflow: ellipsis;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-height: 1.5em;
        height: 3em;
      }
      &-more {
        text-decoration: underline;
      }
    }
  }
  .friends {
    background: #efefef;
    padding: 60px 0;
    .list {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .item {
        margin: 20px 0;
      }
    }
    .list-warp {
      position: relative;
      width: 70%;
    }
    .list-right {
      width: 2rem;
    }
    .list-left {
      width: 2rem;
    }
  }
}
@include media-breakpoint-down(lg) {
  .home {
    .btn-view {
      background: rgba(41, 67, 154, 0.65);
      display: block;
    }
    .products {
      .product {
        &-title {
          font-size: 1rem;
          width: 100%;
          .btn-view {
            display: none;
          }
        }
      }
    }
    .about {
      padding: 2rem 0rem 2rem 1rem;
      &-des {
        padding: 1rem 0 0 0;
        font-size: 1rem;
        &-warp {
          width: calc(100% - 1rem);
        }
      }
    }
    .brand {
      padding: 2rem 1rem;
      h2 {
        text-align: left;
      }
      &-items {
        padding: 1rem 0;
        // height: 500px;
      }
      &-item {
        width: 100%;
        padding: 1rem;
        height: 100%;
        margin: 0 0rem;
        img {
          height: auto;
        }
        &-title {
          padding: 0.5rem 0;
        }
        &-warp {
          justify-content: space-between;
        }
        &-content {
          -webkit-line-clamp: 2;
        }
      }
    }
    .friends {
      padding: 2rem 1rem;
      .about-title {
        text-align: left;
      }
      .list {
        &-warp {
          width: 100%;
        }
        .item {
          padding: 10px;
          margin: 0;
        }
      }
    }
  }
}
@include media-breakpoint-down(md) {
}
@media (min-width: 992px) {
  .col-md-1-5 {
    width: 20%;
  }
}
</style>
